// Shared framer-motion presets: a hard "stamped down" ease instead of soft
// material fades, to match the brutalist visual language (no blur, no float).
export const snap = { duration: 0.35, ease: [0.16, 1, 0.3, 1] };

export const stampContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

export const stampUp = {
  hidden: { opacity: 0, y: 16, scale: 0.96 },
  visible: { opacity: 1, y: 0, scale: 1, transition: snap },
};

export const stampIn = {
  hidden: { opacity: 0, scale: 0.85, rotate: -6 },
  visible: { opacity: 1, scale: 1, rotate: 0, transition: snap },
};

export const viewportOnce = { once: true, margin: '-80px' };
